/* eslint-disable no-undef */
import React from 'react';
import './style.sass';

const RegistrationSteps = () => (
  <div className="box-shadow">
    <div className="registration-steps">
      <div className="sidebar">
        <h3 className="sidebar-header">{I18n.t('provider_signup.page.registration_steps')}</h3>
        <ul className="numbered-list__blue">
          <li>{I18n.t('provider_signup.page.registration_step_1')}</li>
          <li>{I18n.t('provider_signup.page.registration_step_2')}</li>
          <li>{I18n.t('provider_signup.page.registration_step_3')}</li>
          <li>{I18n.t('provider_signup.page.registration_step_4')}</li>
        </ul>
      </div>
    </div>
  </div>
);

export default RegistrationSteps;
